import _toConsumableArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 8px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { Checkbox } from './Checkbox';
var Wrapper = styled.div(_templateObject());

var getOptions = function getOptions(options) {
  return options.map(function (option) {
    return typeof option === 'string' ? {
      label: option,
      value: option
    } : option;
  });
};

export var Group = function Group(_ref) {
  var name = _ref.name,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      options = _ref.options,
      children = _ref.children;

  var _useState = useState(function () {
    return options && options.length > 0 ? getOptions(options).map(function (option) {
      return option.value;
    }) : React.Children.map(children, function (child) {
      return child.props.value;
    });
  }),
      _useState2 = _slicedToArray(_useState, 1),
      allValue = _useState2[0];

  var _useState3 = useState(value || defaultValue || []),
      _useState4 = _slicedToArray(_useState3, 2),
      checkedValues = _useState4[0],
      setCheckedValues = _useState4[1];

  var onToggleOption = useCallback(function (e) {
    var values = _toConsumableArray(checkedValues);

    var optionIndex = values.indexOf(e.target.value);

    if (optionIndex === -1) {
      values.push(e.target.value);
    } else {
      values.splice(optionIndex, 1);
    } // if pass value, we do not modify checkedValue directly


    if (!value) {
      setCheckedValues(values);
    }

    if (onChange) {
      onChange(values.filter(function (val) {
        return allValue.includes(val);
      }));
    }
  }, [allValue, checkedValues, onChange, value]);
  useEffect(function () {
    if (value && value !== checkedValues) {
      setCheckedValues(value);
    }
  }, [checkedValues, value]);
  var childrenForRender = options && options.length > 0 ? getOptions(options).map(function (option) {
    return (
      /*#__PURE__*/
      React.createElement(Checkbox, {
        key: option.value,
        name: name,
        disabled: option.disabled || disabled,
        value: option.value,
        checked: checkedValues.includes(option.value),
        onChange: onToggleOption
      }, option.label)
    );
  }) : React.Children.map(children, function (child, index) {
    return (
      /*#__PURE__*/
      React.cloneElement(child, {
        key: index,
        name: name,
        checked: checkedValues.includes(child.props.value),
        onChange: onToggleOption
      })
    );
  });
  return (
    /*#__PURE__*/
    React.createElement(Wrapper, null, childrenForRender)
  );
};
Group.defaultProps = {
  options: []
};